import React  from 'react'
import ImageMap from 'virtual_congress/components/image_map'
import {  } from '../reducer.jsx'
import {EmailShareButton, FacebookShareButton, InstapaperShareButton, LineShareButton, LinkedinShareButton, LivejournalShareButton, MailruShareButton, OKShareButton, PinterestShareButton, PocketShareButton, RedditShareButton, TelegramShareButton, TumblrShareButton, TwitterShareButton, ViberShareButton, VKShareButton, WhatsappShareButton, WorkplaceShareButton } from "react-share"; import { EmailIcon, FacebookIcon, FacebookMessengerIcon, InstapaperIcon, LineIcon, LinkedinIcon, LivejournalIcon, MailruIcon, OKIcon, PinterestIcon, PocketIcon, RedditIcon, TelegramIcon, TumblrIcon, TwitterIcon, ViberIcon, VKIcon, WeiboIcon, WhatsappIcon, WorkplaceIcon } from "react-share";
import CustomCss from "virtual_congress/components/custom_css";

export default function EventBooth({imageMap,...props}) {

  const startChat = () => {
    // createChat via imageMap.account_organization_id
    console.log("Starting chat")
  }

  const onClick = (hotspot) => {
    //return null;
  }

  return (
    <>
      <CustomCss accountOrganization={imageMap.account_organization}/>
      <ImageMap onClick={onClick} imageMap={imageMap}/>
        <div className="text-center" style={{
          position: "fixed", 
          bottom: "40px", 
          textAlign: "center",
          right: 0,
          left: 0,
          width: "100%"
        }}>
        
        <EmailShareButton url="www.flave.at" title={imageMap.title}>
          <EmailIcon size={32} round={true}/>
        </EmailShareButton>

        <FacebookShareButton url="www.flave.at" title={imageMap.title}>
          <FacebookIcon size={32} round={true}/>
        </FacebookShareButton>
          
        <FacebookShareButton url="www.flave.at" title={imageMap.title}>
          <FacebookMessengerIcon size={32} round={true}/>
        </FacebookShareButton>

        <InstapaperShareButton url="www.flave.at" title={imageMap.title}>
          <InstapaperIcon size={32} round={true}/>
        </InstapaperShareButton>

        <LineShareButton url="www.flave.at" title={imageMap.title}>
          <LineIcon size={32} round={true}/>
        </LineShareButton>

        <LinkedinShareButton url="www.flave.at" title={imageMap.title}>
          <LinkedinIcon size={32} round={true}/>
        </LinkedinShareButton>

        <LivejournalShareButton url="www.flave.at" title={imageMap.title}>
          <LivejournalIcon size={32} round={true}/>
        </LivejournalShareButton>

        <MailruShareButton url="www.flave.at" title={imageMap.title}>
          <MailruIcon size={32} round={true}/>
        </MailruShareButton>

        <OKShareButton url="www.flave.at" title={imageMap.title}>
          <OKIcon size={32} round={true}/>
        </OKShareButton>

        <PinterestShareButton url="www.flave.at" title={imageMap.title}>
          <PinterestIcon size={32} round={true}/>
        </PinterestShareButton>

        <PocketShareButton url="www.flave.at" title={imageMap.title}>
          <PocketIcon size={32} round={true}/>
        </PocketShareButton>

        <RedditShareButton url="www.flave.at" title={imageMap.title}>
          <RedditIcon size={32} round={true}/>
        </RedditShareButton>

        <TelegramShareButton url="www.flave.at" title={imageMap.title}>
          <TelegramIcon size={32} round={true}/>
        </TelegramShareButton>

        <TumblrShareButton url="www.flave.at" title={imageMap.title}>
          <TumblrIcon size={32} round={true}/>
        </TumblrShareButton>

        <TwitterShareButton url="www.flave.at" title={imageMap.title}>
          <TwitterIcon size={32} round={true}/>
        </TwitterShareButton>

        <ViberShareButton url="www.flave.at" title={imageMap.title}>
          <ViberIcon size={32} round={true}/>
        </ViberShareButton>

        <VKShareButton url="www.flave.at" title={imageMap.title}>
          <VKIcon size={32} round={true}/>
        </VKShareButton>

        <WhatsappShareButton url="www.flave.at" title={imageMap.title}>
          <WhatsappIcon size={32} round={true}/>
        </WhatsappShareButton>

        <WorkplaceShareButton url="www.flave.at" title={imageMap.title}>
          <WorkplaceIcon size={32} round={true}/>
        </WorkplaceShareButton>


      </div>
    </>
  )
}
